/*eslint-disable*/
import React, { useState, useEffect, useContext } from 'react'

import { STYLES, language } from "config";

import TextField from '@mui/material/TextField';
import { styled } from '@mui/material/styles';

import { useSelector, useDispatch } from "react-redux";

import moment from "moment";

import {
    Button,
    Input as RSInput,
    Label,
} from "reactstrap";

import { FirebaseContext } from "common";

import CustomDropDownPicker from '../../components/CustomDropDownPicker';

import { useNavigate, useLocation } from "react-router-dom";
import { get } from 'jquery';
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";


const Input = styled(TextField)({
    '& input:valid + fieldset': {
        borderColor: "grey",
        borderWidth: 2,
        fontColor: "grey",
    },
    '& input:invalid + fieldset': {
        borderColor: 'red',
        borderWidth: 1,
    },
    '& input:valid:focus + fieldset': {
        borderLeftWidth: 4,
        padding: '4px !important', // override inline-style
    },
});


const styles = {
    Card: {
        padding: "5px",
        backgroundColor: "#f9f9f9",
        borderRadius: "10px",
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.4)",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: "10px",
    },
    container: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
        gap: "20px",
    },
    CardHeader: {
        padding: "5px",
        width: "100%",
    },
    CardBody: {
        padding: "10px",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: "30px",
    },
    text: {
        color: "grey",
    },

    checkinput: {
        marginLeft: 25,
        borderColor: "#009ad8",
        borderWidth: 2,
        borderRadius: 8,
        height: 25,
        width: 25,
        marginTop: -0.5,
        marginRight: 5,
    },

    inputStyle: {
        borderWidth: 1,
        borderColor: STYLES.TERTIARY_APP_CLR,
        height: 44,
        backgroundColor: "white",
        fontSize: 16,
        borderRadius: 4,
        color: "grey",

    },
    Row: { display: "flex", flexDirection: "row", gap: "15px" },


}


const usageTypes = [
    { value: "Commercial", label: "Commercial", },
    { value: "Industrial", label: "Industrial", },
]
const propertyTypes = [
    { value: "Warehouse", label: "Warehouse" },
  { value: "Workshop", label: "Workshop" },
  { value: "Mini Factory", label: "Mini Factory" },
  { value: "Factory", label: "Factory" },
  { value: "Storage Unit", label: "Storage Unit" },
  { value: "Investment", label: "Investment" },
  { value: "Industrial Yard", label: "Industrial Yard" },
  { value: "Vacant Land", label: "Vacant Land" },
  { value: "Showroom", label: "Showroom" },
  { value: "Retail", label: "Retail" },
  { value: "Office", label: "Office" },
  { value: "Restaurant", label: "Restaurant" },
  { value: "Hotel", label: "Hotel" },
  { value: "Guesthouse", label: "Guesthouse" },
  { value: "Medical Suite", label: "Medical Suite" },
  { value: "Business Centre", label: "Business Centre" },
  { value: "Service Station", label: "Service Station" },
  { value: "Small Holding", label: "Small Holding" },
  { value: "Full Floor", label: "Full Floor" },
  { value: "Business", label: "Business" },
  { value: "Building", label: "Building" }
]

const enquiryTypes = [
    { label: "To Buy", value: "sale" },
    { label: "To Let", value: "To Let" },
    { label: "Both", value: "both" },
];


const shareTypes = [
    { value: "office", label: "My Office" },
    { value: "province", label: "Other Office" },
    { value: "All Offices", label: "national" }
];


const sourceTypes = [
    { value: "Online enquiry", label: "Online enquiry" },
    { value: "Canvassing", label: "Canvassing" },
    { value: "Board", label: "Board" },
    { value: "Other", label: "Other" }
];



//regex
function isOnlyNumbers(value) {
    console.log(`In number check: ${value}`)
    return /^\d+$/.test(value);
}

function isCountryCode(value) {
    console.log(`In country code check: ${value}`)
    return /^\+\d{1,4}$/.test(value);
}
const phoneRegex =
    /^(\+?\d{1,3}[\s.-]?)?(0?\d{2}[\s.-]?\d{3}[\s.-]?\d{4})$/;
const intlPhoneRegex = /^\+?[1-9]\d{1,14}$/;
const numberRegex =
    /^(?:-(?:[1-9](?:\d{0,2}(?:,\d{3})+|\d*))|(?:0|(?:[1-9](?:\d{0,2}(?:,\d{3})+|\d*))))(?:.\d+|)$/;
const typeRegex = /^[a-zA-Z0-9\\,\\.\s]/g;

export default function UpdateEnquiry() {

    //Reducer 
    const auth = useSelector((state) => state.auth);
    const brokers = useSelector((state) => state.brokers.users);
    const areas = useSelector((state) => state.areaData.areas);
    const enquiryManagementReducer = useSelector((state) => state.enquirydata);


    //const declare
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    //actions Setup
    const { api } = useContext(FirebaseContext);
    const { CreateEnquiry, clearEnquiryErrors, UpdateEnquiry, fetchCurrentAdminsBranchEnquiries } = api;


    //usestates 
    const [enquiryData, setEnquirydata] = useState(location.state?.enquiry);
    const [additionalContact, setAdditionalContact] = useState(false);
    const [threePhasePower, setThreePhasePower] = useState(false);
    const [powerValue, setPowerValue] = useState(50);
    const [brokerList, setBrokerList] = useState([]);
    const [areaList, setAreaList] = useState([]);
    const [state, setState] = useState({
        countryCode: "+27",
        sizeRangeMin: "",
        sizeRangeMax: "",
        address: {
            suburb: "",
            streetNumber: "",
            streetName: "",
            unitNumber: "",
            complexName: "",
            floorNumber: "",
            buildingName: "",
        },
        shareBrokers: [],
        clientName: "",
        businessName: "",
        contactNumber: "",
        email: "",
        typeOfProperty: null,
        additionalNotes: "",
        type: null,
        isThreePhase: "No",
        currentRequirementValue: 5,
        share: auth?.info?.profile?.adminHomeOffice,
        selectedArea: "",
        region: "",
        shareType: "office",
        privacy: false,
        source: null,
        isThreePhase: false,
        other: "",
        OwnerBroker: "",
        additionalContacts: false,
        addedClientName: "",
        addedContactNumber: "",
        AddedEmail: "",
        addedBusinessName: "",
        ...location.state?.enquiry
    });


    //useEffects
    useEffect(() => {
        let arr = [];
        if (brokers) {
            for (let index = 0; index < brokers.length; index++) {
                const element = brokers[index];

                // Populate the list with all brokers, remove brokerHomeOffice filter
                if (element.brokerHomeOffice === auth?.info?.profile?.adminHomeOffice) {
                    arr.push({
                        value: element.id, // The broker ID (or name if preferred)
                        label: `${element.firstName} ${element.lastName}`, // Broker name
                    });
                }
            }
            setBrokerList(arr.sort((a, b) => a.label.localeCompare(b.label)));
        }
    }, [brokers]);

    useEffect(() => {
        let arr = [];
        if (areas) {
            for (let index = 0; index < areas.length; index++) {
                const element = areas[index];

                // Populate the list with all areas, remove brokerHomeOffice filter
                if (element.selectedBranchName === auth?.info?.profile?.adminHomeOffice) {
                    arr.push({
                        value: element.areaId, // The area ID
                        label: `${element.areaName}`, // area name
                    });
                }
            }
            setAreaList(arr.sort((a, b) => a.label.localeCompare(b.label)));
        }
    }, [areas]);

    useEffect(() => {
        if (state?.isThreePhase === "Yes") {
            setThreePhasePower(true);
        }
    }, [state?.isThreePhase]);

    useEffect(() => {
        if (state?.currentRequirementValue !== "0") {
            setPowerValue(state?.currentRequirementValue)
        }
    }, [state?.currentRequirementValue]);

    useEffect(() => {
        if (state?.additionalContacts !== false) {
            setAdditionalContact(state?.additionalContacts)
        }
    }, [state?.additionalContacts]);

    /*=============================================
    =            Functions                       =
    =============================================*/

    function splitPhoneNumber(phoneNumber) {


        console.log("state.PhoneNumber", state.PhoneNumber)

        console.log("phoneNumber", phoneNumber)

        const regex = /^(\+?\d{1,3})?[\s.-]?(0?\d{2}[\s.-]?\d{3}[\s.-]?\d{4})$/;
        const stringNumber = `${phoneNumber}`;
        const match = stringNumber.match(regex);

        console.log("match", match)

        if (!match) {
            throw new Error("Invalid phone number format");
        }

        let countryCode = match[1] || null;
        const localNumber = match[2];

        if (countryCode === "0") {
            countryCode = "+27"
        }

        return {
            countryCode,
            localNumber
        };
    }

    const saveData = (location, data) => {
        setState(prevState => ({
            ...prevState,
            [location]: data,
        }));
    };

    const getAreaDetails = (areaId) => {
        // Function to get area details by areaId
        const area = areas.find((area) => area.areaId === areaId);

        if (area) {
            return {
                area
            };
        }
        return {};
    }

    function getRegionId(region) {
        return Object.keys(region)[0];
    }

    const normalizedDate = (date) => {
        //returns date in formate of YYYY-MM-DD
        return `${moment(date).format("YYYY")}-${moment(date).format(
            "MM"
        )}-${moment(date).format("DD")}`;
    };

    const UpdateEnquiries = () => {
        //Inriching Enquiry Data before sending it to the action
        // !DO NOT CHANGE WITHOUT PERMISSION FROM GAYNOR OR STEVEN!!!
        // ?last updated 17/01/2025
        let EnquiryData = {
            // ?Name of company the enquiry is created for
            id: state?.id,
            CompanyName: state.businessName ? state.businessName : state?.CompanyName || "",
            Email: state.email ? state.email : state?.Email || "",
            countryCode: state.countryCode ? state.countryCode : "",
            contactNumber: state.contactNumber ? state.contactNumber : "",
            PhoneNumber: state.contactNumber ? `${state.countryCode}${state.contactNumber}` : state?.PhoneNumber || "",
            OwnerName: state.clientName ? state.clientName : state.OwnerName || "",
            address: {
                suburb: state.address.suburb ? state.address.suburb : " ",
                streetNumber: state.address.streetNumber //added more address fields
                    ? state.address.streetNumber
                    : " ",
                streetName: state.address.streetName ? state.address.streetName : " ",
                unitNumber: state.address.unitNumber ? state.address.unitNumber : " ",
                complexName: state.address.complexName
                    ? state.address.complexName
                    : " ",
                floorNumber: state.address.floorNumber
                    ? state.address.floorNumber
                    : " ",
                buildingName: state.address.buildingName
                    ? state.address.buildingName
                    : " ",
            },
            selectedArea: state?.selectedArea ? state?.selectedArea : " ", //Added with the approval of Steven 26/09/2024 Adam
            region: state.region ? state.region : "",
            isThreePhase: state.isThreePhase, //Added with the approval of Steven 28/09/2024 jared
            currentRequirementValue: state?.currentRequirementValue
                ? state?.currentRequirementValue
                : 0,
            sizeMax: state?.sizeRangeMax ? state?.sizeRangeMax : state?.sizeMax,
            sizeMin: state?.sizeRangeMin ? state?.sizeRangeMin : state?.sizeMin,
            status: "Active",
            source: state?.source !== "Other" ? state?.source : state?.other,
            typeOfProperty: state.typeOfProperty,
            notes: state?.additionalNotes ? state?.additionalNotes : state?.notes,
            type: state.type,
            share: state.share,
            pullforward: "false",
            shareType: state.shareType,
            privacy: state.privacy,
            shareBrokers: state.shareBrokers ? [...state.shareBrokers] : [],
            ownerBroker: state?.OwnerBroker ? state?.OwnerBroker : state?.ownerBroker,
            // dates need to be normalized for mobile calendar
            markedDate: state?.markedDate,
            enquiryDate: state?.enquiryDate,
            office: state?.office ? state?.office : auth?.info?.profile?.adminHomeOffice,
            additionalContacts: state?.additionalContacts === false ? false : true,
            addedClientName: state?.additionalContacts ? state?.addedClientName : "",
            addedContactNumber: state?.additionalContacts ? state?.addedContactNumber : "",
            AddedEmail: state?.additionalContacts ? state?.AddedEmail : "",
            addedBusinessName: state?.additionalContacts ? state?.addedBusinessName : "",
            isThreePhase: threePhasePower === true ? "Yes" : "No",
            updatedDate: new Date().getTime()
        };
        if (state.clientName || state.OwnerName) {
            if (isCountryCode(state.countryCode) && isOnlyNumbers(state.contactNumber)) {
                if (
                    numberRegex.test(state.sizeMin && state.sizeMax) === true
                ) {
                    if (typeRegex.test(state.type) === true) {
                        if (
                            (!state.privacy &&
                                (state.shareType === "province" ||
                                    state.shareType === "office") &&
                                state.share !== null) ||
                            state.shareType === "national" ||
                            state.privacy
                        ) {
                            console.log(`EnquiryData before update: ${JSON.stringify(EnquiryData)}`)
                            dispatch(UpdateEnquiry(EnquiryData));
                            dispatch(fetchCurrentAdminsBranchEnquiries());
                            navigate(-1)
                        } else {
                            alert(language.share);
                        }
                    } else {
                        alert(language.proper_input_sale_type);
                    }
                } else {
                    alert(language.proper_input_size);
                }
            } else {
                alert(language.proper_input_mobile);
                alert("Please provide a valid phone number with no special characters.");
            }
        } else {
            alert(language.proper_input_name);
        }


    }



    /*=====  End of Functions  ======*/



    return (
        <div style={styles.container}>
            <div style={styles.Card}>

                <div style={styles.CardHeader}>

                    <p className='h4' style={styles.text}>Enquiry Details</p>  </div>

                <div style={styles.Row}>

                    <Input
                        variant="outlined"
                        fullWidth
                        value={state?.sizeMin}
                        onChange={(value) => {
                            saveData("sizeMin", value.target.value);
                            saveData("sizeRangeMin", value.target.value);
                        }}
                        type="text"
                        label="Min Size"
                    />

                    <Input

                        variant="outlined"
                        fullWidth
                        value={state?.sizeMax}
                        onChange={(value) => {
                            saveData("sizeMax", value.target.value);
                            saveData("sizeRangeMax", value.target.value);
                        }}
                        type="text"
                        label="Max Size"
                    />

                </div>

                <div style={styles.Row}>


                    <div
                        style={{
                            width: "100%",
                            position: "relative",
                            zIndex: 7,
                        }}
                    >


                        <CustomDropDownPicker
                            borderColor="grey"
                            options={brokerList}
                            isMulti={true}
                            onChange={(selectedBrokers) => {
                                saveData("shareBrokers", selectedBrokers)
                            }}
                            placeholder="Broker Areas"
                            value={state.shareBrokers}
                        /></div>

                    <div
                        style={{
                            width: "100%",
                            position: "relative",
                            zIndex: 6,
                        }}
                    >

                        <CustomDropDownPicker
                            borderColor="grey"
                            options={brokerList}
                            isMulti={false}
                            value={state?.OwnerBroker ? state?.OwnerBroker : state?.ownerBroker || ""}
                            onChange={(e) => {
                                saveData("OwnerBroker", e);
                            }}
                            placeholder="Select Owner Broker"
                        //value={state.OwnerBroker}
                        /></div>

                </div>


                <div style={styles.Row}>

                    <div
                        style={{
                            width: "100%",
                            position: "relative",
                            zIndex: 5,
                        }}
                    >

                        <CustomDropDownPicker
                            borderColor="grey"
                            options={propertyTypes}
                            isMulti={false}
                            onChange={(e) => saveData("typeOfProperty", e)}
                            placeholder="Select A Type of Property"
                            value={state.typeOfProperty}
                        /></div>

                    <div
                        style={{
                            width: "100%",
                            position: "relative",
                            zIndex: 4,
                        }}
                    >

                        <CustomDropDownPicker
                            borderColor="grey"
                            options={usageTypes}
                            isMulti={false}
                            onChange={(e) => saveData("industrialCommercial", e)}
                            placeholder="Select A Usage Type"
                            value={state.industrialCommercial}
                        /></div>

                </div>


                <div style={styles.Row}>
                    <div
                        style={{
                            width: "100%",
                            position: "relative",
                            zIndex: 3,
                        }}
                    >
                        <CustomDropDownPicker
                            borderColor="grey"
                            options={enquiryTypes}
                            isMulti={false}
                            onChange={(e) => saveData("type", e)}
                            placeholder="Select A Enquiry Type"
                            value={state.type}
                        /></div>

                    <div
                        style={{
                            width: "100%",
                            position: "relative",
                            zIndex: 2,
                        }}
                    >

                        <CustomDropDownPicker
                            borderColor="grey"
                            options={sourceTypes}
                            isMulti={false}
                            onChange={(e) => saveData("source", e)}
                            placeholder="Select A Source Type"
                            value={state.source}
                        />
                    </div>

                </div>

                <div style={styles.Row}>

                    <div
                        style={{
                            width: "100%",
                            position: "relative",
                            zIndex: 2,
                        }}
                    >

                        <CustomDropDownPicker
                            borderColor="grey"
                            options={sourceTypes}
                            isMulti={false}
                            onChange={(e) => saveData("source", e)}
                            placeholder="Select A Source Type"
                            value={state.source}
                        />
                    </div>

                </div>

                <div style={styles.Row}>
                    <Input
                        multiline
                        variant="outlined"
                        rows={4}
                        fullWidth
                        onChange={(value) => {
                            value.preventDefault();
                            saveData("additionalNotes", value.target.value);
                            saveData("notes", value.target.value);
                        }}
                        type="text"
                        label="Notes"
                        value={state?.additionalNotes ? state?.additionalNotes : state?.notes || ""}
                    />
                </div>

            </div>


            <div style={styles.Card}>

                <div style={styles.CardHeader}>

                    <p className='h4' style={styles.text}>Power Requirements</p>  </div>

                <div style={styles.Row}>


                </div>

                <div style={styles.Row}>
                    <Label
                        check
                        style={{ ...styles.text, fontSize: 16, marginTop: 10, marginBottom: 10, marginLeft: 20 }}
                    >
                        3 Phase Power:
                        <RSInput
                            type="checkbox"
                            style={styles.checkinput}
                            checked={threePhasePower}
                            onChange={(e) => {
                                const newValue = !threePhasePower;
                                setThreePhasePower(newValue);
                                saveData("isThreePhase", newValue);
                            }}
                        />
                    </Label>
                    <Label
                        check
                        style={{ ...styles.text, fontSize: 16, marginTop: 10, marginBottom: 10, marginLeft: 60 }}
                    >Current(A): </Label>
                    <input
                        type="range"
                        min="0"
                        max="5000"
                        step={50}
                        value={powerValue}
                        onChange={(e) => {
                            setPowerValue(e.target.value)
                            saveData("currentRequirementValue", e.target.value)
                        }}
                    />
                    <span>{`${powerValue}A`}</span>

                    <Label
                        check
                        style={{ ...styles.text, fontSize: 16, marginTop: 10, marginBottom: 10, marginLeft: 60 }}
                    >Enter Current Manually </Label>
                    <Input
                        variant="outlined"
                        value={powerValue}
                        onChange={(value) => {
                            value.preventDefault();
                            setPowerValue(value.target.value)
                            saveData("currentRequirementValue", value.target.value);
                        }}
                        type="text"
                    />
                </div>

            </div>


            <div style={styles.Card}>

                <div style={styles.CardHeader}>

                    <p className='h4' style={styles.text}>Client Details</p>  </div>



                <div style={styles.Row}>

                    <Input
                        variant="outlined"
                        fullWidth
                        value={state?.clientName ? state?.clientName : state?.OwnerName || ""}
                        onChange={(value) => {
                            value.preventDefault();
                            saveData("clientName", value.target.value);
                        }}
                        type="text"
                        label="Contact Person"
                    />

                    <Input

                        variant="outlined"
                        fullWidth
                        value={state?.businessName ? state?.businessName : state?.CompanyName || ""}
                        onChange={(value) => {
                            value.preventDefault();
                            saveData("businessName", value.target.value);
                        }}
                        type="text"
                        label="Business Name"
                    />

                </div>

                <div style={styles.Row}>
                    <div style={{ flex: "0 0 110px", marginRight: "10px" }}>
                        <PhoneInput
                            //country={"za"}
                            value={state.countryCode}
                            onChange={(code) => saveData("countryCode", `+${code}`)}
                            inputStyle={{
                                width: "100%",
                                height: 55,
                                fontSize: 16,
                                borderRadius: 4,
                                border: `1px solid grey`,
                                backgroundColor: "white",
                                color: "grey",
                            }}
                            dropdownStyle={{ zIndex: 1000 }}
                        />
                    </div>
                    <div style={{ flex: "0 0 545px", marginRight: "1px" }}>
                        <Input
                            variant="outlined"
                            fullWidth
                            onChange={(value) => {
                                value.preventDefault();
                                let phone = value.target.value;

                                if (phone.startsWith("0")) {
                                    phone = phone.substring(1);
                                }

                                saveData("contactNumber", phone);
                            }}
                            type="text"
                            label="Contact Number"
                            value={state.contactNumber ? state.contactNumber : ""}
                        />
                    </div>
                    <div style={{ flex: "1" }}>
                        <Input
                            variant="outlined"
                            fullWidth
                            onChange={(value) => {
                                value.preventDefault();
                                saveData("email", value.target.value);
                            }}
                            type="text"
                            label="Contact Email"
                            value={state.email ? state.email : state.Email || ""}
                        />
                    </div>
                </div>



            </div>


            <div style={styles.Card}>

                <div style={styles.CardHeader}>

                    <p className='h4' style={styles.text}>Additional Contact Details</p>  </div>

                <div style={styles.Row}>
                    <Label
                        check
                        style={{ ...styles.text, fontSize: 16, marginTop: 10, marginBottom: 10, }}
                    >
                        Add additional contact:
                        <RSInput
                            type="checkbox"
                            style={styles.checkinput}
                            checked={additionalContact}
                            onChange={(e) => {
                                const newValue = !additionalContact;
                                setAdditionalContact(newValue);
                                saveData("additionalContacts", newValue);
                            }}
                        />
                    </Label>

                </div>
                <div>
                    {additionalContact && (
                        <>
                            <div style={styles.Row}>
                                <Input
                                    variant="outlined"
                                    fullWidth
                                    onChange={(e) => saveData("addedClientName", e.target.value)}
                                    type="text"
                                    label="Additional Contact Person"
                                    value={state?.addedClientName || ""}
                                />

                                <Input
                                    variant="outlined"
                                    fullWidth
                                    onChange={(e) => saveData("addedBusinessName", e.target.value)}
                                    type="text"
                                    label="Business Name"
                                    value={state?.addedBusinessName || ""}
                                />
                            </div>

                            <div style={styles.Row}>
                                <Input
                                    variant="outlined"
                                    fullWidth
                                    onChange={(e) => saveData("addedContactNumber", e.target.value)}
                                    type="text"
                                    label="Contact Number"
                                    value={state?.addedContactNumber || ""}
                                />

                                <Input
                                    variant="outlined"
                                    fullWidth
                                    onChange={(e) => saveData("AddedEmail", e.target.value)}
                                    type="text"
                                    label="Contact Email"
                                    value={state?.AddedEmail || ""}
                                />
                            </div>
                        </>
                    )}
                </div>

            </div>


            <div style={styles.Card}>

                <div style={styles.CardHeader}>

                    <p className='h4' style={styles.text}>Shared Details</p>  </div>

                <div style={styles.Row}>
                    <Label
                        check
                        style={{ ...styles.text, fontSize: 16, marginTop: 10, marginBottom: 10, }}
                    >
                        Dont Share Enquiry:
                        <RSInput
                            type="checkbox"
                            style={styles.checkinput}
                            checked={state.privacy}
                            onChange={(value) => {
                                saveData("privacy", !state.privacy);
                            }}
                        />
                    </Label>


                </div>

                <div style={styles.Row}>

                    <div
                        style={{
                            width: "100%",
                            position: "relative",
                            zIndex: 1,
                        }}
                    >

                        <CustomDropDownPicker
                            borderColor="grey"
                            options={shareTypes}
                            isMulti={false}
                            onChange={(e) => saveData("shareType", e)}
                            placeholder="Select A Share Type"
                            value={state.shareType}
                        /></div>

                </div>


            </div>



            <div style={styles.Card}>

                <Button

                    style={{ backgroundColor: STYLES.PRIMARY_APP_CLR, color: "white", width: "100%", height: 50, borderRadius: 10, fontSize: 20, fontWeight: "bold", marginTop: 20 }}

                    onClick={UpdateEnquiries}
                >
                    Update Enquiry
                </Button>

            </div>

        </div>
    )
}
